// @ts-ignore
import { track } from 'lib/analytics'

/**
 * References the current user under `window` to derive the user's current role.
 * @returns A new Avo collaborator role event value
 */

export function getCollaboratorRole() {
  if (typeof window !== 'undefined') {
    // @ts-ignore otherwise it fails during mocha tests step
    const role = window.currentUser?.currentRegistry?.currentUserRole

    if (role === 'partner') {
      return track.CollaboratorRole.PARTNER
    }

    if (role === 'owner') {
      return track.CollaboratorRole.REGISTRANT
    }

    if (role === 'collaborator') {
      return track.CollaboratorRole.COLLABORATOR
    }
  }
}

/**
 * Get the Avo Product type.
 * @returns An Avo ProductType property value
 */
export function getProductType(isGiftCard: boolean) {
  return isGiftCard ? track.ProductType.GIFT_CARD : track.ProductType.PRODUCT
}
